import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { IconButton } from '@mui/material';
import { formatPhoneWithCountryCode } from '@/utils/phoneNumber';

export type WhatsAppInputAdornmentProps = {
  phone?: string | null;
  'aria-label'?: string;
};

const WhatsAppInputAdornment = ({
  phone,
  'aria-label': ariaLabel = 'Abrir WhatsApp',
}: WhatsAppInputAdornmentProps) => {
  const formattedPhone = formatPhoneWithCountryCode(phone);
  if (!formattedPhone) return null;

  return (
    <IconButton
      component='a'
      href={`https://wa.me/${formattedPhone}`}
      target='_blank'
      rel='noopener noreferrer'
      aria-label={ariaLabel}
      size='small'
      edge='end'
      sx={{
        color: '#25D366',
        '&:hover': {
          color: '#1da851',
          bgcolor: 'rgba(37, 211, 102, 0.12)',
        },
      }}
    >
      <WhatsAppIcon fontSize='small' sx={{ color: 'inherit' }} />
    </IconButton>
  );
};

export default WhatsAppInputAdornment;
